/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const HeadsUpDisplay = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 26 25" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <g fillRule="nonzero"><path d="M15.81 16.69a3.82 3.82 0 0 0-1.7.42c.46-1.66 2.58-2.59 3.28-2.8.29-.09.35-.26.27-.44l-.34-.87a.31.31 0 0 0-.42-.21c-1.28.42-5 2.08-5 6.45 0 2.25 1.22 4.12 3.55 4.12a3.42 3.42 0 0 0 3.38-3.43 3 3 0 0 0-3.02-3.24zm-.35 5c-1.21 0-1.74-1.21-1.74-2.24a1.84 1.84 0 0 1 1.72-1.3 1.77 1.77 0 0 1 0 3.54h.02zM22.58 16.61h-1.3v-2h3.33c.16 0 .29-.13.29-.29v-1a.3.3 0 0 0-.29-.28h-4.72a.29.29 0 0 0-.29.28v4.41a.49.49 0 0 0 .47.52h2.3a1.64 1.64 0 0 1 1.8 1.67 1.72 1.72 0 0 1-1.72 1.77 3 3 0 0 1-1.93-.84.28.28 0 0 0-.37 0l-.74.74c-.19.17-.17.27 0 .5a3.78 3.78 0 0 0 2.95 1.24A3.5 3.5 0 0 0 26 19.92a3.17 3.17 0 0 0-3.42-3.31z" /><path d="M7.27 8.33a7.7 7.7 0 0 1 12.04-.26l4.54-3.16-2.41-2.38C15.631-1.31 7.84.01 3.62 5.548-.6 11.088.196 18.95 5.44 23.53c.57.432 1.172.82 1.8 1.16l2.41-5a9.85 9.85 0 0 1-.86-.57A7.73 7.73 0 0 1 7.27 8.33z" /></g>
      </g>
    </svg>
  </span>
);

HeadsUpDisplay.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

HeadsUpDisplay.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default HeadsUpDisplay;
